import React from 'react';
import '../../assets/css/PropertyPagination.css';

const PropertyPagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) {
    return null;
  }
  
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    // Always show first page
    if (startPage > 1) {
      pageNumbers.push(
        <li key={1} className="page-item">
          <button 
            className="page-link" 
            onClick={() => onPageChange(1)}
          >
            1
          </button>
        </li>
      );
      
      if (startPage > 2) {
        pageNumbers.push(
          <li key="ellipsis1" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }
    
    // Generate page links
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(i)}
            disabled={i === currentPage}
          >
            {i}
          </button>
        </li>
      );
    }
    
    // Always show last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(
          <li key="ellipsis2" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      
      pageNumbers.push(
        <li key={totalPages} className="page-item">
          <button 
            className="page-link" 
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }
    
    return pageNumbers;
  };
  
  return (
    <nav className="property-pagination">
      <ul className="pagination">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link page-link--prev"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
        </li>
        
        {renderPageNumbers()}
        
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button
            className="page-link page-link--next"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default PropertyPagination;